<template>
  <div>
    <Modal
      :styles="{ top: '20px', width: 'auto', maxWidth: '1024px' }"
      :value="true"
      title="Stats Modal"
      :closable="false"
      :mask-closable="false"
      class="stats-modal"
    >
      <div
        slot="header"
        class="d-flex justify-content-between align-items-center"
      >
        <h5>{{ $t("competition.top") }}</h5>
        <Button
          @click="() => $emit('close')"
          type="text"
          icon="md-close"
          class="modal-close-btn"
        ></Button>
      </div>
      <Alert v-if="serverError.length" type="error"> {{ serverError }} </Alert>
      <div class="table-special-div">
        <table
          v-if="!loading"
          class="table-stats table table-bordered dt-responsive table-striped nowrap w-100 ml-0"
        >
          <thead>
            <tr>
              <th>#</th>
              <th class="first-table-head">
                {{ $t("user.table.name") }}/{{ $t("user.table.surname") }}
              </th>
              <th>{{ $t("competition.scored") }}</th>
              <!-- <template v-for="stage in competition.stages">
                <th :key="stage._id + Date.now()">{{ stage.name }}</th>
              </template> -->
            </tr>
          </thead>
          <tbody>
            <template v-for="(player, i) in players">
              <tr>
                <td>{{ i + 1 }}</td>
                <td>
                  <Tooltip placement="top-start" style="width: 170px;">
                    <span
                      class="text-overflow-style single-groups-clamp-text w-100"
                    >
                      {{ player.firstName }} {{ player.secondName }}
                    </span>
                    <div slot="content">
                      {{ player.firstName }} {{ player.secondName }}
                    </div>
                  </Tooltip>
                </td>
                <td>
                  {{ player.goals }}
                </td>
                <!-- <template v-for="stage in competition.stages">
                  <td :key="stage._id + Date.now()">
                    <span>{{
                      player[stage.name.replace(" ", "_") + "_Goals"]
                    }}</span>
                  </td>
                </template> -->
              </tr>
            </template>
          </tbody>
        </table>
      </div>

      <div slot="footer" class="text-center">
        <!-- <ButtonGroup class="modal-footer-btn">
          <Button @click="handleSubmit('addDriverForm')" :loading="loading" type="success"
            style="min-width: 150px"><b>{{$t('global.save')}}</b></Button>
        </ButtonGroup> -->
      </div>
    </Modal>
  </div>
</template>

<script>
export default {
  props: ["teams", "competition"],
  name: "TopScorersModal",
  data() {
    return {
      serverError: [],
      players: [],
      loading: false
    };
  },
  methods: {
    async getGoalsByPlayer() {
      try {
        this.loading = true;
        console.log(this.teams);
        const res = await this.$http.post("/team/topScorers", {
          teams: this.teams
        });
        if (res.data.length) {
          let players = res.data.map(id => {
            return {
              goals: id.totalPoints,
              jersey: id.jerseyNumber,
              ...id.playerId
            };
          });
          this.players = players;
          console.log("players :>> ", players);
          // await this.getGoalsByStages()
        }
        this.loading = false;
      } catch (error) {
        console.log(error);
      }
    }
    // async getGoalsByStages() {
    //   this.loading = true
    //   for (let i = 0; i < this.competition.stages.length; i++) {
    //     const element = this.competition.stages[i];
    //     try {
    //       const res = await this.$http.post("/team/stages", { teamId: this.team._id, stageId: element._id })
    //       for (let k = 0; k < this.players.length; k++) {
    //         if (res.data.find((data) => data.playerId._id === this.players[k]._id))
    //           this.players[k][element.name.replace(' ', '_') + '_Goals'] = res.data.find((data) => data.playerId._id === this.players[k]._id).totalPoints
    //         else this.players[k][element.name.replace(' ', '_') + '_Goals'] = 0
    //       }
    //     } catch (error) {
    //       console.log(error)
    //     }
    //   }
    //   this.loading = false
    // }
  },
  async mounted() {
    await this.getGoalsByPlayer();
  }
};
</script>

<style scoped>
table.table-stats {
  border-radius: 0.25em;
  border-collapse: collapse;
}

.disabled td {
  color: #495057;
}

.table-stats tbody tr {
  transition: background 0.25s ease;
}

.stats-modal :global(.ivu-modal) {
  width: max-content !important;
}
.stats-modal .table-striped tbody tr:nth-of-type(odd):hover,
.table-stats tbody tr:hover {
  background: #e4e4e4 !important;
}

.stats-modal :global(.ivu-modal-header) {
  padding-bottom: 0;
}

.stats-modal :global(.ivu-modal-header),
.stats-modal :global(.ivu-modal-footer) {
  border: none;
}

.stats-modal :global(.ivu-modal-footer) {
  padding: 0;
}

.stats-modal :global(.ivu-modal-content) {
  /* background: #454751; */
  /* border: 1px solid #272727; */
}

.stats-modal h5,
.stats-modal table td,
.stats-modal table th,
.stats-modal button {
  color: #495057 !important;
}

.stats-modal button:hover {
  filter: brightness(0.8);
  color: #495057 !important;
}

.stats-modal button {
  /* background: #454751 !important; */
}

.stats-modal :global(.ivu-modal-mask) {
  opacity: 0.8 !important;
  /* background-color: #000; */
}

.stats-modal .table-striped tbody tr:nth-of-type(odd) {
  /* background: #3d3f48 !important; */
}

.stats-modal table {
  font-size: small;
  /* table-layout: fixed; */
}

.stats-modal table td,
.stats-modal table th {
  padding: 0.35rem;
  /* border-color: #333333 !important; */
  vertical-align: middle;
}

@media only screen and (max-width: 575.98px) {
  .stats-modal :global(.ivu-modal) {
    margin: 10px auto !important;
    width: 100% !important;
  }
  .stats-modal :global(.ivu-tooltip) {
    width: 110px !important;
    min-width: 110px !important;
  }
}

@media only screen and (max-width: 767.98px) {
  .stats-modal :global(.ivu-modal-header) {
    padding: 10px 10px 0;
  }

  .stats-modal :global(.ivu-modal-body) {
    padding: 10px;
    overflow-x: hidden;
  }

  .stats-modal .table-stats {
    margin-bottom: 0;
  }

  .table-special-div {
    overflow-x: scroll;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/competitions/brackets/TopScorersModal.vue